<script>
// Main Components
import 'vue-loading-overlay/dist/vue-loading.css';
import Layout from '@/router/layouts/main';
import FiltersCard from '@/components/widgets/cards/filters-search';
import FieldsMenu from '@/components/widgets/grids/grid-fields-menu.vue';
import Grid from './components/grid.vue';

// Mixins
import dateMixin from '@/mixins/dateMixin';
import textMixin from '@/mixins/textMixin';

// Other
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/fr';

export default {
  page: {
    title: 'DashboardPriceHistories',
  },
  mixins: [dateMixin, textMixin],
  components: {
    Layout,
    Multiselect,
    FiltersCard,
    DatePicker,
    Grid,
    FieldsMenu,
  },
  data() {
    return {
      selectedSuppliers: [],
      searchText: '',
      dateRange: [],
      filters: null,
    };
  },
  created() {
    this.search();
  },
  methods: {
    search() {
      this.filters = {
        suppliersIdPublic: this.selectedSuppliersIds,
        search: this.searchText,
        startDate: this.dateRange[0],
        endDate: this.dateRange[1],
      };
    },
    cancelSearch() {
      this.searchText = '';
      this.selectedSuppliers = [];
      this.dateRange = [];
      this.search();
    },
  },
  computed: {
    suppliersList() {
      return this.$store.state.cache.suppliers;
    },
    selectedSuppliersIds() {
      return this.selectedSuppliers != null
        ? this.selectedSuppliers.map((a) => a.idPublic)
        : [];
    },
    fieldsComputed() {
      return [
        {
          key: 'supplierName',
          label: this.$t('suppliers.supplierName'),
          sortable: true,
        },
        {
          key: 'itemName',
          label: this.$t('items.itemName'),
          sortable: true,
        },
        {
          key: 'created',
          label: this.$t('general.date'),
          sortable: true,
          class: 'centered-field',
        },
        {
          key: 'price',
          label: this.$t('general.price'),
          sortable: true,
          class: 'centered-field',
        },
        {
          key: 'difference',
          label: this.$t('general.difference'),
          sortable: true,
          class: 'centered-field',
        },
        {
          key: 'percentage',
          label: this.$t('general.percentage'),
          sortable: false,
          class: 'centered-field',
        },
      ];
    },
  },
};
</script>

<template>
  <Layout
    :title="$t('pricehistories.pricehistories')"
    :no-card="true"
    @esc-double-pressed="cancelSearch"
  >
    <div class="flex-box">
      <b-input-group class="search-bar custom-inventory-shadow">
        <b-form-input
          id="searchInput"
          type="text"
          style="border: none"
          :placeholder="$t('general.search')"
          @keydown.escape.prevent="cancelSearch()"
          @keydown.enter.prevent="search()"
          v-model="searchText"
        ></b-form-input>
        <b-input-group-append>
          <b-button
            style="border: none"
            variant="outline-light"
            @click="search()"
          >
            <i class="bx bx-search"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <FieldsMenu
        id="dashboard-price-histories-grid"
        class="flex-push"
        :dropup="true"
        :fields="fieldsComputed"
      />
    </div>

    <FiltersCard @cancel="cancelSearch" @search="search">
      <template #row>
        <b-row>
          <b-col sm="12" lg="3">
            <b-form-group
              id="group-suppliers"
              :label="$t('suppliers.suppliers')"
              label-class="no-bold"
              label-for="supplierSelect"
            >
              <multiselect
                id="supplierSelect"
                ref="multiselectSupplier"
                v-model="selectedSuppliers"
                :options="suppliersList"
                :label="'name'"
                track-by="idPublic"
                :placeholder="$t('general.pickAValue')"
                @remove="multiselectClosed($refs.multiselectSupplier)"
                :multiple="true"
                :show-labels="false"
                :hide-selected="true"
                :close-on-select="false"
                :clear-on-select="false"
                :searchable="false"
              >
                <template v-slot:noOptions>
                  {{ $t('general.noResult') }}
                </template>
                <template slot="tag" slot-scope="{ option, remove }">
                  <span
                    class="custom__tag badge badge-primary badge-pill"
                    style="font-size: 1em; margin-right: 5px; cursor: pointer"
                    v-html="option.name"
                    @click="remove(option)"
                  >
                  </span>
                </template>
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col sm="12" lg="3">
            <b-form-group
              id="group-datepicker"
              :label="$t('general.date')"
              label-class="no-bold"
              label-for="dateSelect"
            >
              <date-picker
                id="dateSelect"
                v-model="dateRange"
                range
                format="YYYY-MM-DD"
                value-type="format"
                :lang="$i18n.locale"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </template>
    </FiltersCard>

    <Grid v-if="filters != null" :filters="filters" :fields="fieldsComputed" />
  </Layout>
</template>

<style scoped>
.search-bar {
  max-width: 500px;
  max-height: 40px;
  background-color: white;
  border-radius: 5px;
}
</style>